$(window).on('load', () => {
  // let offset = 150;
  // $(document).on('scroll', onScroll);
  // //smoothscroll
  // $('a[href^="#"]').on('click', function (e) {
  //   e.preventDefault();
  //   $(document).off('scroll');
  //   $('a').each(function () {
  //     $(this).removeClass('active');
  //   });
  //   $(this).addClass('active');
  //   const target = this.hash;
  //   const menu = target;
  //   const $target = $(target);
  //   $('html, body')
  //     .stop()
  //     .animate(
  //       {
  //         scrollTop: $target.offset().top + 2,
  //       },
  //       500,
  //       'swing',
  //       function () {
  //         window.location.hash = target;
  //         $(document).on('scroll', onScroll);
  //       }
  //     );
  // });
  // window.onscroll = function () {
  //   if (document.getElementById('myBar')) myFunction();
  // };
  // function myFunction() {
  //   var winScroll =
  //     document.body.scrollTop || document.documentElement.scrollTop;
  //   var height =
  //     document.documentElement.scrollHeight -
  //     document.documentElement.clientHeight;
  //   var scrolled = (winScroll / height) * 100;
  //   document.getElementById('myBar').style.width = scrolled + '%';
  // }
  // function onScroll(event) {
  //   var scrollPos = $(document).scrollTop();
  //   $('.subNav a').each(function () {
  //     var currLink = $(this);
  //     const refElement = $(currLink.attr('href'));
  //     const bodyRect = document.body.getBoundingClientRect();
  //     const elemRect = refElement[0].getBoundingClientRect();
  //     const offset2 = elemRect.top - bodyRect.top;
  //     if (
  //       offset2 <= scrollPos + offset &&
  //       offset2 + refElement.height() > scrollPos - offset
  //     ) {
  //       $('.subNav ul li').removeClass('active');
  //       currLink.parent().addClass('active');
  //     } else {
  //       // currLink.removeClass('active');
  //     }
  //   });
  // }
});
